import React, { useState, useEffect, Fragment, useRef, useCallback, useLayoutEffect } from "react";
import LayoutHOC from "../LayoutHOC";
import { Link, useNavigate } from "react-router-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import { UPDATE_CUSTOMER_DATA, ADD_CUSTOMER_DATA } from "../../utils/constants";
import {
  useCustomerTableMutation,
  useFetchCustomerTableDataMutation,
  useLazyCustomerTableNodeQuery,
} from "../../utils/customer/customerTable";
import { parseJSONValue } from "../../utils/json/parseJSONValue";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import FirstMessage from "../GlobalFeature/MessageAlert/FirstMessage";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import useFormDataAppend from "../../hooks/FormSubmit/useFormDataAppend";
import { useFetchCustomerGroupQuery } from "../../utils/customer/customerTaskTable";
import { CHECK_DUPLICATE_CUSTOMER } from "../../utils/constants";
import { CHECK_DUPLICATE_CUST_DISP_NAME } from "../../utils/constants";
import { ReactComponent as CrosIconCustHome } from "../../assets/images/crosIconCustHome.svg";
import { ReactComponent as Upload } from "../../assets/images/icons/FileUpload.svg";
import { ReactComponent as LeftDoubleArrow } from "../../assets/images/icons/leftArrowDouble.svg";
import { ReactComponent as PersonAvatar } from "../../assets/images/personAvatar.svg";
import { ReactComponent as CameraIcon } from "../../assets/images/cameraIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/images/newPencilEdit.svg";
import { ReactComponent as Accordion } from "../../assets/images/accordion.svg";
import CropComponent from "../UniversalComponents/CropComponent";

import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { pushAlert } from "../../utils/alertSlice";
import { useDispatch } from "react-redux";
import { BASE_URL } from "../../utils/constants";
import { ReactComponent as UploadIcon } from "../../assets/images/uploadIcon.svg";
import { ReactComponent as HoverCopy } from "../../assets/images/icons/HoverCopy.svg";
import { parseJSONFields } from "../../utils/json/parseJSONFields";
import { ReactComponent as BackIcon } from "../../assets/images/backIconAddCustomer.svg";
import { getInitials } from "../../utils/utilityFunctions/stringUtility";
import BasicSelect from "../Task/BasicSelect";
import { logDOM } from "@testing-library/react";
import AddGroupDrawer from "../company/AddGroupDrawer";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import { Edit2Icon } from "lucide-react";
import EditDrawer from "./EditDrawer";
import { valueColorCodeCheck } from "../../utils/utilityFunctions/valueColorCodeCheck";
import { getCompanyId, getOrganizationId } from "../../utils/utilityFunctions/localServices";

const CustomerGenInfo = ({
  closeButton,
  isDuplicate,
  isEditMode,
  setIsEditMode,
  addCustomerId,
  setAddCustomerId,
  customerGeneralData,
  allCustomerData,
  onSave,
  handleDelete,
  isAddMode,
  setIsAddMode,
  isAddingNew,
  setIsAddingNew,
  groupEditData,
  setGroupEditData,
  customerGroup,
  refetchCustomerGroup,
  handleGroupDrawerClose,
  open,
  anchorParentRef,
}) => {
  console.log(customerGroup, "customerGroup");
  console.log(groupEditData, "groupEditData");
  console.log(customerGeneralData, "customerGeneralData");
  console.log(addCustomerId, "addCustomerId");

  const [cusdipName, setCusdipName] = useState("");
  const user = useRequireAuth();
  const [customerGroups, setCustomerGroups] = useState([]);
  const defaultCustomerData = {
    org_id: user?.org_id,
    customer_group_id: "",
    customer_group: "",
    customer_name: "",
    customer_display_name: "",
    website: "",
    type: "",
    // customerFile: null,
    business_category: "",
    customer_code: "",
    country_id: "",
    phone: "",
    email: "",
    // customerfile: "",
    // isNewGroup: false,
  };

  const [customerData, setCustomerData] = useState(defaultCustomerData);

  const [isSeleted, setIsSeleted] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [tempSelectedFile, setTempSelectedFile] = useState(null);
  const [groupList, setGroupList] = useState([]);
  const [imageCropDrawerOpen, setImageCropDrawerOpen] = useState(false);
  const [editMenuDrawer, setEditMenuDrawer] = useState(false);

  const validationRules = {
    customer_group: {
      required: true,
      errorMessage: "Customer Group is required.",
    },
    customer_name: {
      required: true,
      errorMessage: "Customer Name is required.",
    },
    type: {
      required: true,
      errorMessage: "Type is required.",
    },
    phone: {
      required: isAddingNew,
      errorMessage: "Phone no is required.",
    },
    email: {
      required: isAddingNew,
      errorMessage: "Email is required",
    },
    customer_display_name: {
      required: isAddingNew,
      errorMessage: "Contact Name is required.",
    },
  };

  const { values, errors, touched, handleChange, handleBlur, validateField, isFormValid } = useCustomFormValidation(
    customerData,
    validationRules
  );

  const dispatch = useDispatch();

  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });

  const navigate = useNavigate();
  const { token } = useRequireAuth();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  const compId = parsedCompanyData.company_id;
  const [isFormFrozen, setIsFormFrozen] = useState(false);
  const fileInputRef = useRef(null);
  const [typeData, setTypeData] = useState({});
  const [newOption, setNewOption] = useState("");
  const [getDataId, setGetDataId] = useState();
  const [groupDuplicate, setGroupDuplicate] = useState();

  const resetCustomerGroupData = () => {
    setCustomerData({
      customer_group_id: "",
      customer_group: "",
      customer_code: "",
      country_id: "",
      business_category: "",
      email: "",
      phone: "",
      type: "",
      customer_display_name: "",
      website: "",
    });
    setGroupEditData({});
  };

  const parsedtypeData = Array.isArray(parseJSONValue(typeData)) ? parseJSONValue(typeData) : [];
  //const [CustomerTableDrop, { data: customerCommnData }] = useCustomerTableMutation();

  const [
    fetchOptionData,
    { data: optionData, isSuccess: isSuccessOptions, isFetching: isFetchingOptions, isError: isErrorOptions },
  ] = useLazyCustomerTableNodeQuery();

  // const parsedData = Array.isArray(parseJSONValue(customerCommnData?.data))
  //   ? parseJSONValue(customerCommnData?.data)
  //   : [];

  const [isOpen, setIsOpen] = useState(false);

  const dropclickoutside = useClickOutside(() => {
    setIsOpen(null);
  });

  const toggleDropdown = (event) => {
    const { id } = event.currentTarget;
    const newIsOpen = isOpen === id ? null : id;

    setIsOpen(newIsOpen);
    // if (newIsOpen) {
    //   const completedata = {
    //     model_name: "customers",
    //     field_name: id,
    //   };
    //   CustomerTableDrop({ token: token, data: completedata });
    // }
  };

  const handleCloseCropDrawer = () => {
    setImageCropDrawerOpen(false);
  };

  const fetchData = async () => {
    const result = await fetchOptionData({
      token: token,
      orgId: getOrganizationId(),
      companyId: getCompanyId(),
      fieldName: "type",
    });
  };

  useEffect(() => {
    if (customerGroup?.data && Array.isArray(customerGroup?.data)) {
      setCustomerGroups((prev) => {
        const newData = customerGroup?.data;
        if (JSON.stringify(newData) !== JSON.stringify(prev)) {
          return newData;
        }
        return prev;
      });
    }
  }, [customerGroup?.data]);

  const hasRunRef = useRef(false);

  useLayoutEffect(() => {
    let timer;
    if (!hasRunRef.current && customerData?.customer_group) {
      //setIsAddingNew(open==="customer_group")
      hasRunRef.current = true;
      timer = setTimeout(() => {
        setIsAddingNew(open === "customer_group");
        setGroupEditData({ customerData });
      }, 500);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [customerData?.customer_group]);

  const handleOptionChange = (event, item) => {
    const name = event.currentTarget.getAttribute("name");
    handleChange({
      target: {
        name,
        value: item?.value,
      },
    });
    setCustomerData({ ...customerData, [name]: item?.value });
    setIsOpen(null);
  };

  const handleDispName = (name) => {
    // setCusdipName(event.target.value);
    checkCustName(customerData[name]);
    // checkCustDispName(event.target.value);
  };
  const handleInputChange = (event) => {
    handleChange(event);
    const { name, value } = event.target;

    if (name === "group") {
      const item = customerGroups.find((group) => group.customer_group === value);
      setCustomerData({
        ...customerData,
        customer_group_id: item?.customer_group_id,
        customer_group: item?.customer_group,
        // customer_name: item?.customer_group,
        customer_code: item?.customer_code,
        country_id: item?.country_id,
        business_category: item?.business_category,
        email: item?.email,
        phone: item?.phone,
        // isNewGroup: false,
        // type: item?.type,
        customer_display_name: item?.customer_display_name,
        website: item?.website,
      });
    } else {
      setCustomerData({ ...customerData, [name]: value });
    }
  };

  const checkCustName = async (name) => {
    try {
      const response = await fetch(CHECK_DUPLICATE_CUSTOMER, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ search_customer: name, company_id: compId }),
      });
      const data = await response.json();
      if (data?.success || data?.data?.success || data?.data?.status) {
        dispatch(pushAlert({ message: data?.message, type: "success", visible: true }));
      } else {
        dispatch(pushAlert({ message: data?.message, type: "danger", visible: true }));
        console.log("Error saving customer data:", await response?.text());
      }
    } catch (error) {
      dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
      console.log("Error submitting form:", error);
    }
  };

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setSelectedFile(URL.createObjectURL(file));
  //   }
  // };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setTempSelectedFile(URL.createObjectURL(file));
    setImageCropDrawerOpen(true);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      setSelectedFile(URL.createObjectURL(file));
    }
  };

  // const [
  //   fetchCustomerTableData,
  //   { data: customerTableALL, isLoading: customerListLoading, isFetching: customerListFetching },
  // ] = useFetchCustomerTableDataMutation();

  // const refetchCustomerData = useCallback(() => {
  //   fetchCustomerTableData({
  //     companyId: parsedCompanyData.company_id,
  //     owner: parsedCompanyData.owner,
  //     pagination: `?page=1`,
  //     token: token,
  //   });
  // }, [token]);

  // useEffect(() => {
  //   refetchCustomerData();
  // }, [token]);

  const handleButtonClick = async (event) => {
    event.preventDefault();

    if (isFormFrozen !== true && event?.target?.customer_group?.value === "") {
      validationRules.customer_group = {
        required: true,
        errorMessage: "Customer Group is required.",
      };
    }
    const formValid = isFormValid();
    if (!formValid) {
      return;
    }

    const jsonData = {
      company_id: parsedCompanyData.company_id,
      recordType: "customerinfo",

      created_by: user?.user_id || "",
      ...customerData,
      profile_pic: selectedFile,
      ...(!isDuplicate && { customer_id: customerGeneralData?.id }),
    };
    onSave(jsonData);
    setIsEditMode(true);
  };

  useEffect(() => {
    if (customerGeneralData) {
      setCustomerData(customerGeneralData);
    }

    // Step 1: Set basic customer data

    // Step 2: Enrich with group data
    const item = customerGroup?.data.find(
      (group) =>
        group?.customer_group_id === (customerGeneralData?.customer_group_id || customerData?.customer_group_id)
    );

    console.log("after item find", item);

    if (item) {
      setCustomerData((prev) => ({
        ...prev,
        customer_group_id: item.customer_group_id,
        customer_group: item.customer_group,
        //customer_code: item.customer_code,
        customer_code: customerGeneralData?.customer_code,
        country_id: item.country_id,
        business_category: item.business_category,
        email: item.email,
        phone: item.phone,
        type: item.type,
        customer_display_name: item.customer_display_name,
        website: item.website,
      }));
    }
  }, [customerGroup?.data]);

  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };

  const handleChangeCustomerDisplay = (e) => {
    setCustomerData({ ...customerData, customer_display_name: e.target.value });
    handleChange(e);
    setCusdipName(e.target.value);
  };

  const handleAddNewOption = () => {
    if (newOption.trim() !== "") {
      const isDuplicate = customerGroups.find(
        (group) => group.customer_group.toLowerCase() === newOption.toLowerCase()
      );

      if (!isDuplicate) {
        const updatedGroups = [...customerGroups, { customer_group: newOption }];
        setCustomerGroups(updatedGroups);
        setNewOption(newOption);
        setCustomerData({
          ...customerData,
          customer_group_id: null,
          customer_group: newOption,
          customer_name: newOption,
          // isNewGroup: true,
        });
        setGroupDuplicate();
      } else {
        validationRules.customer_group = {
          required: true,
          errorMessage: "Already Present Customer Group.",
        };
        setGroupDuplicate("Already Present Customer Group.");
        dispatch(
          pushAlert({
            type: "danger",
            message: "Already Present Customer Group. Please Change the Group",
            visible: true,
          })
        );
      }
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter" && newOption.trim() !== "") {
      event.preventDefault();
      handleAddNewOption();
    }
  };

  const handleClearGroup = () => {
    setCustomerData(defaultCustomerData);
    setGroupDuplicate();
  };

  const options = [{ customer_group: "+ Add New", isAddNew: true }, ...customerGroups];

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        dispatch(pushAlert({ message: "Copied", type: "success", visible: true }));
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const handleFileChangeImg = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(URL.createObjectURL(file));
    }
  };

  return (
    <>
      {isEditMode ? (
        <section id="genInfo" className={`${isDuplicate ? "" : ""} grow min-w-0`}>
          <form className="h-full flex flex-col gap-5 justify-between pb-5 pt-5" onSubmit={handleButtonClick}>
            <div className={`px-3 gap-4 grow  min-h-0 flex flex-col overflow-y-auto thinscrollbar`}>
              {customerData?.customer_group_id && (
                <div className="  px-3 pt-2 pb-5 border-t border-b border-[#D2DAE1] bg-[#FAFAFA]">
                  <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                      <p className="text-[14px] font-[500] text-[#1D4469]">Group Information</p>
                      <div className="mr-2">
                        <div
                          className="cursor-pointer"
                          onClick={() => {
                            resetCustomerGroupData();
                          }}
                        >
                          <BackIcon />
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-[10px]">
                      <div
                        className="w-14 h-14 p-1 flex items-center justify-center rounded-[2.857px] border-[0.571px] border-dashed border-[#BCD0E3] bg-[#1D4469]
"
                      >
                        <p
                          className="text-[25px] font-normal capitalize leading-[150%] text-white font-[Poppins]
"
                        >
                          {getInitials(customerData?.customer_display_name).toUpperCase()}
                        </p>
                      </div>
                      <div className="flex flex-col justify-between  ">
                        <div className="flex gap-4 ">
                          <p
                            className="text-[11px] font-light capitalize leading-[16.5px] text-[#848687] font-[Poppins] min-w-28
"
                          >
                            Group*
                          </p>
                          <p
                            onClick={() => {
                              setIsAddingNew(true);
                              setGroupEditData({ customerData });
                            }}
                            className="text-[10px] font-normal leading-[150%] capitalize font-poppins text-[#2999BC] cursor-pointer"
                          >
                            {customerData?.customer_group}
                          </p>
                        </div>
                        <div className="flex gap-4">
                          <p
                            className="text-[11px] font-light capitalize leading-[16.5px] text-[#848687] font-[Poppins] min-w-28
"
                          >
                            Client Type
                          </p>
                          <p className="text-[10px] font-normal leading-[150%] capitalize font-poppins ">
                            {customerData?.type}
                          </p>
                        </div>
                        <div className="flex gap-4 ">
                          <p
                            className="text-[11px] font-light capitalize leading-[16.5px] text-[#848687] font-[Poppins] min-w-28
"
                          >
                            Country
                          </p>
                          <p className="text-[10px] font-normal leading-[150%] capitalize font-poppins ">
                            {customerData?.country_id}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* fake accordion */}
              {customerData?.customer_group_id && (
                <div className="px-3 py-2 flex justify-between items-center bg-[#E9EDF0]">
                  <div className="text-[14px] font-medium capitalize text-[#1D4469] font-[Poppins]">
                    Customer Information
                  </div>
                  <div>
                    <Accordion />
                  </div>
                </div>
              )}
              {/* <div className="flex items-center gap-2">
                  <EditIcon />
                  <button className="self-start">Edit</button>
                </div>
                <EditDrawer isOpen={editMenuDrawer} onClose={() => setEditMenuDrawer(false)} />

              </div> */}

              {/* Group 1*/}
              {!customerData?.customer_group_id && (
                <div className={` ${isFormFrozen ? "pointer-events-none" : ""} px-3`}>
                  <label htmlFor={`customer_group_id`} className={`block  text-535252 text-14 font-500 mb-1`}>
                    Group<span className="text-red-700">* </span>
                    {errors?.customer_group ? (
                      <span className="text-red-700">{errors.customer_group}</span>
                    ) : (
                      groupDuplicate && <span className="text-red-700">{groupDuplicate}</span>
                    )}
                    {/* <button className="ml-2"><LeftDoubleArrow/></button> */}
                  </label>
                  {console.log("Customergrps", customerGroups)}

                  <BasicSelect
                    options={customerGroups.map((option) => ({
                      label: option?.customer_group,
                      value: option?.customer_group,
                    }))}
                    inputBoxSize="medium"
                    name={"group"}
                    label={"group"}
                    value={customerData?.group}
                    onChange={handleInputChange}
                    showSearch
                    addButton
                    addButtonLabel={"Add New Group"}
                    addButtonAction={() => setIsAddingNew(true)}
                  />

                  {/* {isAddingNew ? (
                    // <MenuItem >
                    <TextField
                      autoFocus
                      value={newOption || ""}
                      onChange={(e) => setNewOption(e.target.value)}
                      onKeyDown={(e) => handleKeyPress(e)}
                      onBlur={handleAddNewOption}
                      placeholder="Add New Group"
                      fullWidth
                      sx={{
                        backgroundColor: "white",
                        "& .MuiOutlinedInput-root": {
                          height: "30px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          "&:hover fieldset": {
                            borderColor: "#999",
                          },
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          display: "none",
                        },
                        "& input": {
                          height: "30px",
                          padding: "0 8px",
                          fontSize: "13px",
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <button
                            className="w-4 h-4 mx-2 flex items-center justify-center"
                            onClick={(e) => {
                              e.preventDefault();
                              setIsAddingNew(false);
                              handleClearGroup();
                            }}
                          >
                            <CloseIcon className="w-4 h-4" />
                          </button>
                        ),
                      }}
                    />
                  ) : (
                    <FormControl fullWidth>
                      {console.log(options, "customerData aakash")}
                      <Autocomplete
                        options={options}
                        getOptionLabel={(option) => option.customer_group || ""}
                        value={
                          // isAddingNew?.newOption?.customer_group
                          //   ? { customer_group: isAddingNew?.newOption?.customer_group }
                          //   : { customer_group: isAddingNew?.newOption }
                          customerData
                        }
                        onChange={(e, newValue) => {
                          if (newValue?.isAddNew) {
                            setIsAddingNew(true);
                          } else {
                            // setIsAddingNew((prevState) => ({
                            //   ...prevState,
                            //   newOption: newValue,
                            // }));

                            setCustomerData({
                              ...customerData,
                              customer_group_id: newValue?.customer_group_id,
                              customer_group: newValue?.customer_group,
                              // customer_name: newValue?.customer_group,
                              customer_code: newValue?.customer_code,
                              country_id: newValue?.country_id,
                              business_category: newValue?.business_category,
                              email: newValue?.email,
                              phone: newValue?.phone,
                              // isNewGroup: false,
                              type: newValue?.type,
                              customer_display_name: newValue?.customer_display_name,
                              website: newValue?.website,
                            });
                          }
                        }}
                        filterOptions={(options, state) => {
                          const inputValue = state?.inputValue || "";
                          const filtered = options.filter(
                            (option) =>
                              option?.customer_group?.toLowerCase().includes(inputValue?.toLowerCase()) ||
                              option?.isAddNew
                          );
                          return filtered;
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select an option"
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              style: {
                                height: "30px",
                                fontSize: "12px",
                                fontFamily: "poppins",
                              },
                              endAdornment: (
                                <>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleClearGroup();
                                    }}
                                    style={{
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      padding: "0 4px",
                                      color: "red",
                                    }}
                                  >
                                    {params.inputProps.value?.length > 0 && params.InputProps.endAdornment}
                                  </button>
                                </>
                              ),
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                border: "1px solid #ccc",
                                "&.Mui-focused": {
                                  border: "1px solid #1D5D9B",
                                  outline: "none",
                                  boxShadow: "none",
                                },
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                display: "none",
                              },
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <MenuItem {...props} key={option.customer_group_id}>
                            {option.customer_group}
                          </MenuItem>
                        )}
                        sx={{
                          "& .MuiAutocomplete-inputFocused": {
                            border: "none",
                            boxShadow: "none",
                          },
                        }}
                      />
                    </FormControl>
                  )} */}
                </div>
              )}

              {/* Name 3*/}
              <div className="px-3">
                <label htmlFor={`customer_name`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Name<span className="text-red-700">* </span>
                  {errors.customer_name && <span className="text-red-700 ">{errors.customer_name}</span>}
                </label>
                <input
                  type={`text`}
                  id={`customer_name`}
                  name="customer_name"
                  value={customerData?.customer_name}
                  onChange={handleInputChange}
                  onBlur={() => {
                    handleBlur();
                    handleDispName("customer_name");
                  }}
                  // onKeyUp={handleDispName}
                  className={`w-full bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block px-2.5 py-1`}
                  placeholder={`Enter Name  . . . `}
                />
              </div>

              {/* Type 2*/}
              <div className={"px-3"}>
                <label htmlFor={`type`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Type<span className="text-red-700">* </span>
                  {errors && <span className="text-red-700"> {errors.type}</span>}
                </label>

                <BasicSelect
                  options={optionData?.data?.map((option) => ({
                    label: option?.value,
                    value: option?.value,
                  }))}
                  inputBoxSize="medium"
                  name={"type"}
                  label={"type"}
                  onChange={handleInputChange}
                  value={customerData?.type}
                  showSearch
                  apiCall={fetchData}
                />
              </div>

              {/*Contact Name 4*/}
              <div className="px-3">
                <label htmlFor={`customer_display_name`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Cus. Display Name<span className="text-red-700">* </span>
                  {errors && <span className="text-red-700"> {errors.customer_display_name}</span>}
                </label>
                <input
                  type={`text`}
                  value={cusdipName || customerData?.customer_display_name}
                  id={`customer_display_name`}
                  name="customer_display_name"
                  onChange={handleChangeCustomerDisplay}
                  onBlur={handleBlur}
                  className={`bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full px-2.5 py-1`}
                  placeholder={`Enter Customer Display Name  . . . `}
                />
              </div>

              {/* Client Type 5*/}
              {/* <div className="">
                <label htmlFor={`business_category`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Client Type
                  {errors && <span className="text-red-700"> {errors.business_category}</span>}
                </label>

                <div className="relative">
                  <button
                    id="business_category"
                    onClick={(event) => {
                      isAddingNew && toggleDropdown(event);
                    }}
                    className={`w-full h-[30px] rounded-5px tracking-wide  text-535252   px-2 leading-tight focus:outline-none focus:ring-grey-100 py-1 text-center inline-flex items-center justify-between border  focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5
                    ${!isAddingNew ? "pointer-events-none  bg-F2F2F2 border-DFE2E5" : "bg-white border-DFE2E5"}
                `}
                    type="button"
                    style={{
                      borderRadius: "1px",
                    }}
                  >
                    <span
                      className={`tracking-wide py-1 text-xs rounded-full text-black`}
                      style={{
                        backgroundColor: customerData?.business_category?.color_code,
                      }}
                    >
                      {customerData?.business_category || "Select an option"}
                    </span>

                    <span>
                      <i className={`bi bi-chevron-${isOpen === "business_category" ? "up" : "down"}`}></i>
                    </span>
                  </button>

                  {isOpen === "business_category" && (
                    <div
                      ref={dropclickoutside}
                      id="dropdownRadioBgHover"
                      className={`w-full z-10 bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-700 dark:divide-gray-600 absolute `}
                    >
                      <ul
                        className="p-3 space-y-1 text-sm text-gray-700 dark:text-gray-200 h-[210px] overflow-auto"
                        aria-labelledby="status"
                        style={{
                          borderRadius: "1px",
                          border: "0.4px solid #535252",
                          background: "#FFF",
                          boxShadow: "0px 0px 4px 0px #535252",
                        }}
                      >
                        {parsedData &&
                          parsedData?.map((item, index) => (
                            <li
                              key={index}
                              className="border-b border-DADADA"
                              name="business_category"
                              onClick={(event) => {
                                handleOptionChange(event, item);
                              }}
                            >
                              <div className="flex items-center p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-600">
                                {item?.color_code && (
                                  <input
                                    id={`status-radio-${index}`}
                                    type="radio"
                                    value={item && item?.value}
                                    name="business_category"
                                    className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-grey-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                    checked={customerData?.business_category?.value === item?.value}
                                    onChange={(event) => {
                                      handleOptionChange(event, item);
                                    }}
                                    style={{
                                      backgroundColor: item?.color_code,
                                      width: "25px",
                                      height: "25px",
                                      borderRadius: "5px",
                                      backgroundSize: "3rem",
                                    }}
                                  />
                                )}

                                <label
                                  htmlFor={`status-radio-${index}`}
                                  className="w-full ml-2 text-sm tracking-wide text-383838 rounded dark:text-gray-300"
                                >
                                  {item && item?.value}
                                </label>
                              </div>
                            </li>
                          ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div> */}

              {/*  Code 6*/}
              <div className="px-3">
                <label htmlFor={`customer_code`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Code
                </label>
                <input
                  type={`text`}
                  id={`customer_code`}
                  name="customer_code"
                  value={
                    isAddingNew?.newOption?.customer_code
                      ? isAddingNew?.newOption?.customer_code
                      : customerData?.customer_code
                  }
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  className={`w-full rounded-5px text-xs focus:ring-1d4469 focus:border-1d4469 px-2.5 py-1 border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 `}
                  placeholder={`Enter Customer Code `}
                />
              </div>

              {/* Country 7*/}
              {/* <div className="">
                <label htmlFor={`country_id`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Country
                  {errors && <span className="text-red-700"> {errors.country_id}</span>}
                </label>

                <div className="relative">
                  <button
                    id="country_id"
                    onClick={(event) => {
                      isAddingNew && toggleDropdown(event);
                    }}
                    className={`w-full h-[30px] rounded-5px text-535252  px-2 leading-tight  focus:outline-none focus:ring-grey-100 py-1 text-center inline-flex items-center justify-between border  focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5
                ${!isAddingNew ? "pointer-events-none  bg-F2F2F2 border-DFE2E5" : "bg-white border-DFE2E5"}
              `}
                    type="button"
                    style={{
                      borderRadius: "1px",
                    }}
                  >
                    <span
                      className={`tracking-wide py-1 text-xs rounded-full text-black`}
                      style={{
                        backgroundColor: customerData?.country_id?.color_code,
                      }}
                    >
                      {customerData?.country_id || "Select an option"}
                    </span>

                    <span>
                      <i className={`bi bi-chevron-${isOpen === "country_id" ? "up" : "down"}`}></i>
                    </span>
                  </button>

                  {isOpen === "country_id" && (
                    <div
                      ref={dropclickoutside}
                      id="dropdownRadioBgHover"
                      className={`w-full z-10 bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-700 dark:divide-gray-600 absolute `}
                    >
                      <ul
                        className="p-3 space-y-1 text-sm text-gray-700 dark:text-gray-200 h-[210px] overflow-auto"
                        aria-labelledby="status"
                        style={{
                          borderRadius: "1px",
                          border: "0.4px solid #535252",
                          background: "#FFF",
                          boxShadow: "0px 0px 4px 0px #535252",
                        }}
                      >
                        {parsedData &&
                          parsedData?.map((item, index) => (
                            <li
                              key={index}
                              className="border-b border-DADADA"
                              name="country_id"
                              onClick={(event) => {
                                handleOptionChange(event, item);
                              }}
                            >
                              <div className="flex items-center p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-600">
                                {item?.color_code && (
                                  <input
                                    id={`status-radio-${index}`}
                                    type="radio"
                                    value={item && item?.value}
                                    name="country_id"
                                    className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-grey-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                    checked={customerData?.country_id?.value === item?.value}
                                    onChange={(event) => {
                                      handleOptionChange(event, item);
                                    }}
                                    style={{
                                      backgroundColor: item?.color_code,
                                      width: "25px",
                                      height: "25px",
                                      borderRadius: "5px",
                                      backgroundSize: "3rem",
                                    }}
                                  />
                                )}

                                <label
                                  htmlFor={`status-radio-${index}`}
                                  className="w-full ml-2 text-sm tracking-wide text-383838 rounded dark:text-gray-300"
                                >
                                  {item && item?.value}
                                </label>
                              </div>
                            </li>
                          ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div> */}

              {/* phone 8*/}
              {/* <div>
                <label htmlFor={`phone`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Phone<span className="text-red-700">* </span>
                  {errors && <span className="text-red-700"> {errors.phone}</span>}
                </label>

                <input
                  type={`text`}
                  id={`phone`}
                  name="phone"
                  disabled={!isAddingNew}
                  value={isAddingNew?.newOption?.phone ? isAddingNew?.newOption?.phone : customerData?.phone}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  className={`w-full text-sm  focus:ring-1d4469 focus:border-1d4469 rounded-5px px-2.5 py-1 border  focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5
                no-increment ${!isAddingNew ? "pointer-events-none  bg-F2F2F2 border-DFE2E5" : "bg-white border-DFE2E5"}
                `}
                  placeholder={`Enter Phone No. `}
                  maxLength="16"
                />
              </div> */}

              {/* email 9*/}
              {/* <div>
                <label htmlFor={`email`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Email<span className="text-red-700">* </span>
                  {errors && <span className="text-red-700"> {errors.email}</span>}
                </label>
                <input
                  type={`text`}
                  id={`email`}
                  name="email"
                  disabled={!isAddingNew}
                  onChange={handleInputChange}
                  value={isAddingNew?.newOption?.email ? isAddingNew?.newOption?.email : customerData?.email}
                  className={`w-full rounded-5px text-gray-900 text-sm  focus:ring-1d4469 focus:border-1d4469 px-2.5py-1 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5
                ${!isAddingNew ? "pointer-events-none  bg-F2F2F2 border-DFE2E5" : "bg-white border-DFE2E5"}
                `}
                  placeholder={`Enter Email `}
                />
              </div> */}

              {/* website 10*/}
              {/* <div>
                <label htmlFor={`website`} className={`block  text-535252 text-14 font-500 mb-1`}>
                  Website
                  {errors && <span className="text-red-700"> {errors.website}</span>}
                </label>
                <input
                  type={`text`}
                  id={`website`}
                  name="website"
                  disabled={!isAddingNew}
                  onChange={handleInputChange}
                  value={isAddingNew?.newOption?.website ? isAddingNew?.newOption?.website : customerData?.website}
                  className={`w-full text-gray-900 text-sm  focus:ring-1d4469 focus:border-1d4469 rounded-5px px-2.5 py-1 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5
                ${!isAddingNew ? "pointer-events-none  bg-F2F2F2 border-DFE2E5" : "bg-white border-DFE2E5"}
                `}
                  placeholder={`Enter Website`}
                />
              </div> */}
            </div>
            {!isAddingNew && (
              <div className={`flex justify-end text-md w-full border-t border-BECBD3 pt-3 px-3`}>
                <button
                  onClick={() => {
                    if (!isDuplicate && !addCustomerId) {
                      closeButton();
                    } else {
                      setIsEditMode(false);
                    }
                  }}
                  type={`button`}
                  className={`px-6 py-1 text-16  rounded-5px font-500 bg-F4F4F4 focus:outline-none me-2`}
                >
                  CANCEL
                </button>
                <button
                  type="submit"
                  className="px-6 py-1 text-16 rounded-5px font-500 bg-primary hover:bg-primary-hover text-white focus:outline-none cbtn-transition-bg "
                >
                  {isDuplicate ? "Duplicate" : addCustomerId ? "Update" : "Save"}
                </button>
              </div>
            )}
          </form>
          {isAddingNew && (
            <AddGroupDrawer
              open={isAddingNew}
              groupEditData={groupEditData}
              // fullHeight={false}
              onClose={handleGroupDrawerClose}
              setGroupEditData={setGroupEditData}
              refetch={refetchCustomerGroup}
              anchorParentRef={anchorParentRef}
            />
          )}
        </section>
      ) : (
        <div className="grow min-w-0 h-full">
          {/* <span className="text-16 text-[#434852] font-medium ps-4">View General Info</span> */}
          <div className=" w-full min-h-[23rem]">
            <div className="mt-2">
              <div className="  px-3 pt-2 pb-5 border-t border-b border-[#D2DAE1] bg-[#FAFAFA]">
                <div className="flex flex-col gap-2">
                  <div className="flex items-center justify-between">
                    <p className="text-[14px] font-[500] text-[#1D4469]">Group Information</p>
                    <div className="mr-2">
                      <div className=""></div>
                    </div>
                  </div>
                  <div className="flex gap-[10px]">
                    <div
                      className="w-14 h-14 p-1 flex items-center justify-center rounded-[2.857px] border-[0.571px] border-dashed border-[#BCD0E3] bg-[#1D4469]
"
                    >
                      <p
                        className="text-[25px] font-normal capitalize leading-[150%] text-white font-[Poppins]
"
                      >
                        {getInitials(customerGeneralData?.customer_display_name)?.toUpperCase()}
                      </p>
                    </div>
                    <div className="flex flex-col justify-between  ">
                      <div className="flex gap-4 ">
                        <p
                          className="text-[11px] font-light capitalize leading-[16.5px] text-[#848687] font-[Poppins] min-w-28
"
                        >
                          Group*
                        </p>
                        <p className="text-[10px] font-normal leading-[150%] capitalize font-poppins text-[#2999BC] ">
                          {customerGeneralData?.customer_group}
                        </p>
                      </div>
                      <div className="flex gap-4">
                        <p
                          className="text-[11px] font-light capitalize leading-[16.5px] text-[#848687] font-[Poppins] min-w-28
"
                        >
                          Client Type
                        </p>
                        <p className="text-[10px] font-normal leading-[150%] capitalize font-poppins ">
                          {customerGeneralData?.type}
                        </p>
                      </div>
                      <div className="flex gap-4 ">
                        <p
                          className="text-[11px] font-light capitalize leading-[16.5px] text-[#848687] font-[Poppins] min-w-28
"
                        >
                          Country
                        </p>

                        <p className="text-[10px] font-normal leading-[150%] capitalize font-poppins ">
                          {customerData?.country_id}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full flex items-center justify-center overflow-hidden grow min-h-0 border-t">
              <div className="w-full h-full grid grid-cols-2 gap-4 p-4">
                {[
                  { label: "Group", value: customerGeneralData?.customer_group },
                  { label: "Type", value: customerGeneralData?.type },
                  { label: "Cus. Display Name", value: customerGeneralData?.customer_display_name },
                  {
                    label: "Client Type",
                    value: valueColorCodeCheck(customerGeneralData?.business_category),
                  },
                  { label: "Code", value: customerGeneralData?.customer_code },
                  { label: "Country", value: customerGeneralData?.country_id },
                  { label: "Phone", value: customerGeneralData?.phone },
                  { label: "Email", value: customerGeneralData?.email },
                  { label: "Website", value: customerGeneralData?.website },
                  // { label: "Tax Number", value: customerGeneralData?.tax_no },
                ].map((item, index) => (
                  <div key={index} className="flex flex-col items-start justify-start">
                    <label className="text-[#848687] font-poppins text-base font-light leading-5 capitalize w-full truncate">
                      {item.label}
                    </label>
                    <div className="flex w-full justify-between">
                      <span className="text-[#2C495D] text-14 font-400 font-poppins font-normal leading-6 capitalize w-full max-w-[9rem] truncate">
                        {item.value || "-"}
                      </span>
                      {["Phone", "Email", "Website"].includes(item.label) && (
                        <span
                          onClick={() => handleCopy(item.value || "-")}
                          className="invisible ml-2 cursor-pointer group-hover:visible"
                        >
                          <HoverCopy />
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {imageCropDrawerOpen && (
        <CustomDrawer open={imageCropDrawerOpen} parallelDrawer={true} onClose={handleCloseCropDrawer}>
          <CropComponent
            tempSelectedFile={tempSelectedFile}
            setSelectedFile={setSelectedFile}
            onClose={handleCloseCropDrawer}
          />
        </CustomDrawer>
      )}
    </>
  );
};

export default CustomerGenInfo;
